/* ======================================
================ DARK MODE JS ===========
====================================== */

// 
//   function setCookie(name, value, hours) {
//     let expires = "";
//     if (hours) {
//       const date = new Date();
//       date.setTime(date.getTime() + hours * 60 * 60 * 1000); // 12 hours expiration
//       expires = "; expires=" + date.toUTCString();
//       console.log("Cookie Set:", name + "=" + value, "Expires:", date.toUTCString());
//     }
//     document.cookie = name + "=" + value + expires + "; path=/; SameSite=Lax; Secure";
//   }

//   function getCookie(name) {
//     const nameEQ = name + "=";
//     const cookies = document.cookie.split(';');
//     for (let i = 0; i < cookies.length; i++) {
//       let c = cookies[i].trim();
//       if (c.indexOf(nameEQ) === 0) {
//         return c.substring(nameEQ.length, c.length);
//       }
//     }
//     return null;
//   }

//   function isDarkModeTime() {
//     const now = new Date();
//     const hour = now.getHours();
//     return hour >= 12 || hour < 6;
//   }

//   function applyThemeBasedOnTime() {
//     const savedTheme = getCookie("theme");
//     const toggleBtn = document.getElementById("modeToggle");

//     if (savedTheme) {
//       console.log("Saved Theme from Cookie:", savedTheme);
//       const isDark = savedTheme === "dark";
//       document.body.classList.toggle("dark", isDark);
//       if (toggleBtn) {
//         toggleBtn.checked = isDark;
//       }
//     } else {
//       const isDark = isDarkModeTime();
//       console.log("Auto Theme:", isDark ? "dark" : "light");
//       document.body.classList.toggle("dark", isDark);
//       setCookie("theme", isDark ? "dark" : "light", 12); // Expires in 12 hours
//       if (toggleBtn) {
//         toggleBtn.checked = isDark;
//       }
//     }
//   }

//   document.addEventListener("DOMContentLoaded", function() {
//     const toggleBtn = document.getElementById("modeToggle");
//     if (toggleBtn) {
//       toggleBtn.addEventListener("change", () => {
//         const isDark = document.body.classList.toggle("dark");
//         setCookie("theme", isDark ? "dark" : "light", 12); // Expires in 12 hours
//         console.log("Theme Changed:", isDark ? "dark" : "light");
//       });
//     }
//     applyThemeBasedOnTime();
//   });
// 




  function isDarkModeTime() {
    const now = new Date();
    const hour = now.getHours();
    return hour >= 12 || hour < 6; // Dark mode time is between 12 AM and 6 AM
  }

  function clearStorageIfBeforeMidnight() {
    const now = new Date();
    const hour = now.getHours();
    if (hour < 12) {
      sessionStorage.removeItem("theme");
    }
  }

  function applyThemeBasedOnTime() {
    
    
    const savedTheme = sessionStorage.getItem("theme");
    const toggleBtn = document.getElementById("modeToggle");
    if (savedTheme) {
      console.log("savedTheme =========== ", savedTheme);
      const isDark = savedTheme === "dark";
      applyDarkMode(isDark);
      if (toggleBtn) {
        toggleBtn.checked = isDark;
      }
    } else {
      const isDark = isDarkModeTime();
      console.log("isDark =========== ", isDark);
      applyDarkMode(isDark);
      sessionStorage.setItem("theme", isDark ? "dark" : "light");
      if (toggleBtn) {
        toggleBtn.checked = isDark;
      }
    }
  }
  
  function applyDarkMode(isDark) {
    document.body.classList.toggle("dark", isDark);
  }

  const toggleBtn = document.getElementById("modeToggle");
  if (toggleBtn) {
    toggleBtn.addEventListener("change", () => {
      const isDark = document.body.classList.toggle("dark");
      sessionStorage.setItem("theme", isDark ? "dark" : "light");
      applyDarkMode(isDark);
    });
  }

  applyThemeBasedOnTime();




// LocalStorage Cookies Save Backup

// 
//   function isDarkModeTime() {
//     const now = new Date();
//     const hour = now.getHours();
//     return hour >= 12 || hour < 6;
//   }
//   function applyThemeBasedOnTime() {
//     const savedTheme = localStorage.getItem("theme");
//     const toggleBtn = document.getElementById("modeToggle");
//     if (savedTheme) {
//       console.log("savedTheme =========== ", savedTheme)
//       const isDark = savedTheme === "dark";
//       document.body.classList.toggle("dark", isDark);
//       if (toggleBtn) {
//         toggleBtn.checked = isDark;
//       }
//     } else {
//       const isDark = isDarkModeTime();
//       console.log("isDark =========== ", isDark)
//       document.body.classList.toggle("dark", isDark);
//       localStorage.setItem("theme", isDark ? "dark" : "light");
//       if (toggleBtn) {
//         toggleBtn.checked = isDark;
//       }
//     }
//   }
  
//   const toggleBtn = document.getElementById("modeToggle");
//   if (toggleBtn) {
//     toggleBtn.addEventListener("change", () => {
//       const isDark = document.body.classList.toggle("dark");
//       localStorage.setItem("theme", isDark ? "dark" : "light");
//     });
//   }

//   applyThemeBasedOnTime();
// 